var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18.5,
    r: 18,
    fill: "#0368A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8 11.5778C28.0058 11.9306 27.1513 12.1681 26.2549 12.2754C27.17 11.7268 27.8727 10.8585 28.2031 9.82398C27.3478 10.3323 26.3982 10.7002 25.3895 10.8996C24.581 10.0385 23.4284 9.5 22.1548 9.5C19.7077 9.5 17.7235 11.4842 17.7235 13.9313C17.7235 14.2783 17.7631 14.6167 17.8387 14.9414C14.1554 14.7571 10.8904 12.9925 8.70465 10.3114C8.32308 10.9658 8.10493 11.7268 8.10493 12.5389C8.10493 14.076 8.88608 15.4324 10.0762 16.2272C9.34901 16.2042 8.66649 16.0048 8.06821 15.6729V15.7283C8.06821 17.8759 9.59667 19.6664 11.6226 20.0747C11.2511 20.1754 10.8595 20.2302 10.4556 20.2302C10.1698 20.2302 9.89185 20.2021 9.62115 20.1502C10.1849 21.9105 11.822 23.1921 13.7609 23.228C12.2447 24.416 10.3339 25.1251 8.25756 25.1251C7.89902 25.1251 7.54625 25.1042 7.19995 25.0625C9.1611 26.3195 11.4901 27.0539 13.9927 27.0539C22.1433 27.0539 26.6005 20.3014 26.6005 14.4461C26.6005 14.2538 26.5969 14.0623 26.5875 13.873C27.4544 13.2466 28.206 12.4662 28.8 11.5778Z",
    fill: "#E4F2FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.acb6821eacafb79550fbc15b6b1d609c.svg";
export { ForwardRef as ReactComponent };